// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[dir] .cursor[data-v-3bc70c6a] {\n  cursor: default;\n}\n", ""]);
// Exports
module.exports = exports;
